import { useTranslation } from 'react-i18next';
import { SubscriptionStoryPanel } from '@/presentation/components/metrics/SubscriptionStoryPanel';
import { ClinicScopedReport } from '@/presentation/components/reports/ClinicScopedReport';

/**
 * Suscripción Coofit: una sola historia (plan + deuda + peso vs recaudación).
 */
export function CoofitSubscriptionPage() {
  const { t } = useTranslation();

  return (
    <ClinicScopedReport
      title={t('subscription.title')}
      description={t('subscription.description')}
      hint={t('subscription.hint')}
      permissions={['metrics.plan_billing', 'metrics.plan_recaudacion', 'reports.view']}
    >
      {({ token, clinicId, year, month, setEmailPayload }) => (
        <SubscriptionStoryPanel
          token={token}
          clinicId={clinicId}
          year={year}
          month={month}
          setEmailPayload={setEmailPayload}
        />
      )}
    </ClinicScopedReport>
  );
}
